export const SidebarItems = {
  DashBoard: 'dashBoard',
  OrdersHistory: 'ordersHistory',
  SubscriptionsHistory: 'subscriptionsHistory',
  VisitHistory: 'visitHistory',
  LabOrdersHistory: 'labOrdersHistory',
  Messages: 'messages',
  Tasks: 'tasks',
  Documents: 'documents',
  Education: 'education',
  Settings: 'settings',
  Notifications: 'notifications',
  ProviderGroupInformation: 'providerGroupInformation',
  BrelloApp: 'brelloApp'
};
